import mem from 'mem/dist';

import * as API from '../api/PartiesApi';
import {PartyType} from "../types/Party";


export async function getAllParties(order, filterData, token, getAll) {
  const parties = await API.getAllPartiesNew(order, filterData, token, getAll);
  if (parties === 'Parties not found.') {
    return null;
  }
  return parties;
}

export function getParty(id) {
  return API.getById(id);
}

export function searchByName(name) {
  return API.searchByName(name);
}

export function getByCode(code) {
  return API.getByCode(code);
}

export function getEventsByParty(partyid) {
  return API.getEventsByParty(partyid);
}

export function getExpensesByParty(partyid) {
  return API.getExpensesByParty(partyid);
}

export function activateParty(partyId) {
  return API.activateParty(partyId);
}

export function deactivateParty(partyId) {
  return API.deactivateParty(partyId);
}

export function getEventById(eventid) {
  return API.getEventsById(eventid);
}
export function getMemberStatusFromParty(partyId, memberId) {
  return API.getMemberStatusFromParty(partyId, memberId);
}
export function removeMemberFromParty(partyId, memberId, memberToAssign) {
  return API.removeMemberFromParty(partyId, memberId, memberToAssign);
}

export function CreateEvent(event) {
  return API.createEvent(event);
}

export function updateEvent(event) {
  return API.updateEvent(event);
}
export function updatePartyMember(member) {
  return API.updatePartyMember(member);
}

export function deleteEvent(partyId, eventId) {
  return API.deleteEvent(partyId, eventId);
}
export function setConcierge(partyid, userid, conciergeName) {
  return API.setConcierge(partyid, userid, conciergeName);
}

export function deleteConcierge(partyid) {
  return API.deleteConcierge(partyid);
}

export function getDefaultImagesForEvent() {
  return API.getDefaultImagesForEvent();
}

export function getBookMarkedByPartyId(partyId) {
  return API.getBookMarkedByPartyId(partyId);
}

export function getPollsByPartyId(partyId) {
  return API.getPollsByPartyId(partyId);
}


const memoizedGetAllPartyTypes = mem(API.getPartyTypes, {
  maxAge: 1000 * 60,
});

export async function listActivePartyTypes():Promise<PartyType[]> {
  const types = await memoizedGetAllPartyTypes();
  return types.filter(t => t.status === "active");
}